import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import BookingAttemptsTable from './BookingAttemptsTable';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  return {
    title: 'Booking drop-offs (failed attempts)',
    component: (
      <AdminLayout>
        <BookingAttemptsTable />
      </AdminLayout>
    ),
  };
}

export default action;
